import localScaleManager from "../../../helpers/LocalScaleManager";
import MiniTable from "./miniTable";
import router from "../../../../../routes";
import { tweenConfigs } from "../../../helpers/tweensConfigs";
import { gameConfig } from "../../../helpers/gameConfig";
import { MiniTableMenu } from "./miniTableMenu";

export default class TablesNav {
  constructor(scene) {
    this.scene = scene;
    this.tables = [];
    this.miniTableToMoveDepth = 10;
    this.miniTableToMove = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "mini-table")
      .setOrigin(0)
      .setVisible(true)
      .setDepth(this.miniTableToMoveDepth);
    for (let i = 0; i < this.scene.tableGames.length; i++) {
      this.tables.push(new MiniTable(scene, i, this.miniTableToMoveDepth));
    }
    this.plus = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "plus")
      .setOrigin(0);
    this.plus.setInteractive({ cursor: "pointer" });
    this.plus.on("pointerdown", () => {
      if (this.scene.isSceneObjectsInteractive) {
        if (this.scene.getVisitedTableGame().getClubId()) {
          router.push(`/lobby/${this.scene.getVisitedTableGame().getClubId()}`);
        } else {
          router.push('/home')
        }
      }
    });
    this.plusInitDistance = 0;
    this.menu = new MiniTableMenu(this.scene);
    this.isScrolling = false;
  }

  activateVisitedMiniTable() {
    const visitedTableGameIndex = this.scene.getVisitedTableGameIndex();
    this.tables.forEach((table, i) => {
      if (visitedTableGameIndex !== i) {
        table.deactivate();
      } else {
        table.activate();
      }
    });
  }
  changePosition(x) {
    this.isScrolling = true;
    const miniTable = this.tables[0];
    const miniTableDisplayWidth = miniTable.miniTable.displayWidth;
    let tableX = 0;
    const shapeX =
      x -
      this.scene.gameWidth *
        this.scene.getVisitedTableGameIndex() *
        (miniTable.x >= x ? -1 : 1);
    this.plus.setX(x + this.plusInitDistance);
    this.tables.forEach((table, i) => {
      tableX =
        x +
        miniTable.startDistance +
        i * (miniTableDisplayWidth + miniTable.distanceBetween);
      table.miniTable.setX(tableX);
      table.turnTable.setX(tableX);
      table.text.setX(tableX + (miniTableDisplayWidth - table.text.width) / 2);
      table.shape.x = shapeX;
    });
  }

  scrollTo(positionX, tableIndex, preTableIndex) {
    this.isScrolling = true;
    const miniTable = this.tables[0];
    const miniTableDisplayWidth = miniTable.miniTable.displayWidth;
    let tableX = 0;
    const shapeX = this.scene.gameWidth * (tableIndex - preTableIndex);

    const activeMiniTableX =
      tableIndex * (+miniTableDisplayWidth + miniTable.distanceBetween) +
      miniTable.startDistance +
      positionX;
    if (this.miniTableToMove.x !== activeMiniTableX) {
      // this.miniTableToMove.setDepth(this.miniTableToMoveDepth - 2);
      this.scene.tweens.add({
        targets: this.miniTableToMove,
        x: activeMiniTableX,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
        // onComplete: () => {
        // this.miniTableToMove.setDepth(this.miniTableToMoveDepth);
        // }
      });
    }
    this.scene.tweens.add({
      targets: this.plus,
      x: this.plusInitDistance + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
      onComplete: () => {
        this.activateVisitedMiniTable();
      },
    });
    this.tables.forEach((table, i) => {
      tableX =
        miniTable.startDistance +
        i * (miniTableDisplayWidth + miniTable.distanceBetween) +
        positionX;
      this.scene.tweens.add({
        targets: table.miniTable,
        x: tableX,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
      });
      this.scene.tweens.add({
        targets: table.turnTable,
        x: tableX,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
      });
      this.scene.tweens.add({
        targets: table.shape,
        x: shapeX,
        // x: positionX,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
        onComplete: (_) => {
          this.isScrolling = false;
        },
      });
      this.scene.tweens.add({
        targets: table.text,
        x: tableX + (miniTableDisplayWidth - table.text.width) / 2,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
      });
    });
  }

  removeTable(index) {
    const theTable = this.tables[index];
    theTable.remove();
    this.tables[index] = null;
    this.tables.splice(index, 1);
    for (let i = 0; i < this.scene.tableGames.length; i++) {
      this.tables[i].index = i;
    }
  }
  positionControls(width, height, tableWidth, tableHeight) {
    this.tables.forEach((table) => {
      table.positionControls(tableWidth, tableHeight);
    });
    let plusSize = Math.min(tableWidth / 4.5, tableHeight / 4.5);
    let plusScale = localScaleManager.scaleSprite(
      this.plus,
      plusSize,
      plusSize,
      40,
      1,
      true
    );
    localScaleManager.scaleSpriteTo(this.miniTableToMove, plusScale);

    const initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    let aMiniTable = this.tables[0];
    this.plusInitDistance =
      aMiniTable.startDistance +
      this.tables.length *
        (aMiniTable.miniTable.displayWidth + aMiniTable.distanceBetween);
    this.plus.setPosition(
      initX + this.plusInitDistance,
      aMiniTable.miniTable.y
    );
    this.miniTableToMove.setPosition(
      initX + aMiniTable.startDistance,
      aMiniTable.miniTable.y
    );
    if (this.scene.totalTableGames >= gameConfig.maxTables) {
      if (this.plus.visible) this.plus.setVisible(false);
    } else {
      if (!this.plus.visible) this.plus.setVisible(true);
    }
    this.menu.positionControls(width, height, this.tables[0]);
  }

  reposition(width, height, tableWidth, tableHeight) {
    this.tables.forEach((table) => {
      table.reposition(tableWidth, tableHeight);
    });
    const initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    let aMiniTable = this.tables[0];
    this.plusInitDistance =
      aMiniTable.startDistance +
      this.tables.length *
        (aMiniTable.miniTable.displayWidth + aMiniTable.distanceBetween);
    this.plus.setPosition(
      initX + this.plusInitDistance,
      aMiniTable.miniTable.y
    );
    this.miniTableToMove.setPosition(
      initX + aMiniTable.startDistance,
      aMiniTable.miniTable.y
    );
    if (this.scene.totalTableGames >= gameConfig.maxTables) {
      if (this.plus.visible) this.plus.setVisible(false);
    } else {
      if (!this.plus.visible) this.plus.setVisible(true);
    }
    this.menu.reposition(width, height, this.tables[0]);
  }
}
